import { type JSX, onMount } from 'solid-js';

// The confirm before a terminal Stop (#6753, prototype stopAskHTML `:2150` and the epic
// confirm `:2368`): a named group (`fieldset`) under the job or epic (the prototype's
// `alertdialog` role is the modal shells' alone, `testing/overlay-shells.ts`; this one is
// inline and traps nothing), its words saying what Stop does (the work is cancelled;
// deviation 1). Opening it moves focus to its keep button ("Keep running", "Keep going"),
// never the Stop; Escape or the keep button closes it and hands focus back to the Stop button
// that opened it.

/** The element of this card marked `data-<key>` = `id` (compared, never put in a selector). */
function marked(
  card: Element | null | undefined,
  key: 'stopFor' | 'undoFor',
  id: string,
): HTMLElement | null {
  const attr = key === 'stopFor' ? '[data-stop-for]' : '[data-undo-for]';
  const all =
    card === null || card === undefined ? [] : [...card.querySelectorAll<HTMLElement>(attr)];
  return all.find((el) => el.dataset[key] === id) ?? null;
}

export function StopConfirm(props: {
  readonly id: string;
  /** "Stop the Coder job": the dialog's name. */
  readonly label: string;
  readonly text: string;
  readonly yes: string;
  readonly no: string;
  readonly onYes: () => void;
  readonly onNo: () => void;
}): JSX.Element {
  let noEl: HTMLButtonElement | undefined;
  let root: HTMLFieldSetElement | undefined;
  // The keep button takes focus, as `ConfirmDialog`'s Cancel does: an Enter held from the
  // Stop press never confirms a terminal action.
  onMount(() => noEl?.focus());
  const close = (): void => {
    const back = marked(root?.closest('.mission-card'), 'stopFor', props.id);
    props.onNo();
    back?.focus();
  };
  return (
    <fieldset
      ref={root}
      class="mission-ctl__confirm"
      aria-label={props.label}
      onKeyDown={(e) => {
        if (e.key !== 'Escape') return;
        e.preventDefault();
        e.stopPropagation();
        close();
      }}
    >
      <span>{props.text}</span>
      <span class="mission-ctl__confirm-actions">
        <button
          type="button"
          class="mission-ctl__confirm-yes"
          onClick={() => {
            // Read the card BEFORE the confirm closes: a detached node has no ancestors.
            const card = root?.closest('.mission-card');
            props.onYes();
            queueMicrotask(() => marked(card, 'undoFor', props.id)?.focus());
          }}
        >
          {props.yes}
        </button>
        <button ref={noEl} type="button" class="mission-ctl__confirm-no" onClick={close}>
          {props.no}
        </button>
      </span>
    </fieldset>
  );
}
